import styled from 'styled-components';


export const Initials = styled.div`
  width: 100px;
  height: 100px;
  background-color: #f0f0f0;
  color: #333;
  font-size: 36px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

export const UploadOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  cursor: pointer;
  color: white;
  border-radius: 50%;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    font-family: Inter;
    line-height: 16px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  width: max-content;
  border-radius: 50%;

   &:hover ${UploadOverlay} {
    opacity: 1;
    visibility: visible;
  }
`;

export const Paragraph = styled.p`
  color: #757575;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  margin-top: 10px;
`;

export const Image = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #f0f0f0;
  object-fit: cover;
`;